import { render, staticRenderFns } from "./SlsDL_Sales_Items.vue?vue&type=template&id=5765e1c8"
import script from "./SlsDL_Sales_Items.vue?vue&type=script&lang=js"
export * from "./SlsDL_Sales_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports